import { ETableDataType } from '@aca-new/app/shared/components/table/shared/enums/table-data-type.enum';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppTableDataCellTypeService {
  public readonly tableDataType = ETableDataType;
}
